import React, { useState, useEffect } from "react";
import ProductForm from "./ProductForm";
import { BeerFormState } from "../../../constants/types";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Toast from "../../../common/Toast";
import ArrowLeft from "../../../assets/arrow-left.svg";
import {
  HeaderContainer,
  HeaderTitle,
  BackButtonWrapper,
} from "./ProductCreate.styles";
import { Box } from "@mui/material";
import { useCreateProductMutation } from "../../../queries/product";
import { api } from "../../../api/api";
import { productInventoryEndPoints } from "../../../constants/endpoints";
import { useAppDispatch } from "../../../redux/hooks";
import { setLoading } from "../../../redux/features/slices/appSlice";

const CreateNewProduct: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const orgId = localStorage.getItem("orgId");
  const { mutate: createProduct } = useCreateProductMutation();

  const [quantity_20L, setQuantity_20L] = useState(0);
  const [quantity_30L, setQuantity_30L] = useState(0);
  const [quantity_50L, setQuantity_50L] = useState(0);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchInventoryDetails = async () => {
      try {
        const response = await api.get(
          `${productInventoryEndPoints.productInventory}`,
          {
            params: {
              page: 1,
              limit: 10,
            },
            headers: {
              orgId: localStorage.getItem("organizationId"),
            },
          }
        );

        console.log("Inventory details fetched:", response?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching inventory details:", error);
      }
    };

    fetchInventoryDetails();
  }, []);

  const handleSubmit = (data: BeerFormState) => {
    setError(false);

    console.log("Create Product Payload:", data);

    // Turn the global loader on at submit time and keep it on through the
    // upload, API call, cache invalidation, success toast and route transition
    // so the user sees a single, continuous loader.
    dispatch(setLoading(true));

    createProduct(data, {
      onSuccess: (response) => {
        if (response?.message === "Product created successfully") {
          setToastMessage("Product details have been successfully added");

          setError(false);
          setShowToast(true);

          setTimeout(() => {
            navigate(`/maltora-seller/products`);
            dispatch(setLoading(false));
          }, 2000);
        } else {
          setToastMessage("Failed to add product details. Please try again");

          setError(true);
          setShowToast(true);
          dispatch(setLoading(false));
        }
      },

      onError: (error) => {
        const errorMessage =
          error.message || "Failed to add product details. Please try again";

        setToastMessage(errorMessage);
        setError(true);
        setShowToast(true);
        dispatch(setLoading(false));

        if (axios.isAxiosError(error)) {
          console.error(
            "Error creating product:",
            error.response?.data || error.message
          );
        } else {
          console.error("Unexpected error:", error);
        }
      },
    });
  };

  return (
    <div>
      <HeaderContainer>
        <HeaderTitle variant="body1">Add New Product</HeaderTitle>

        <BackButtonWrapper onClick={() => navigate(`/maltora-seller/products`)}>
          <Box component="img" src={ArrowLeft} alt="explore-products" />
        </BackButtonWrapper>
      </HeaderContainer>

      <Toast
        setShowToast={setShowToast}
        showToast={showToast}
        toastMessage={toastMessage}
        error={error}
      />

      <ProductForm
        formTitle="Add New Product"
        buttonTextOne="Create"
        buttonTextTwo="Reset"
        beerName=""
        description=""
        price=""
        basePrice={0}
        ed={0}
        fileUpload={[]}
        quantity=""
        onSubmit={handleSubmit}
        existingImages={[]}
        isEdit={false}
        abv=""
        ibu=""
        quantity_20L={quantity_20L}
        quantity_30L={quantity_30L}
        quantity_50L={quantity_50L}
      />
    </div>
  );
};

export default CreateNewProduct;
